import {Button} from "react-bootstrap";
import {AiFillCloseCircle} from "react-icons/ai";
import * as React from "react";

export function RemoveArtworkButton({file, reset}: { file: File | undefined, reset: () => void }) {
    return <div className="mt-2 me-2 mb-0 d-flex flex-wrap align-items-center justify-content-between dont-break-out">
        <div className="fw-bold my-1">Artwork File: {file &&
            <span className="ms-2 fw-normal">{file.name}</span>}</div>
        <Button variant="outline-danger"
                className="my-1 py-1 px-2 d-flex align-items-center"
                size="sm"
                style={{lineHeight: 0}}
                onClick={reset}>
            <AiFillCloseCircle className="me-1" size={18}/>
            Remove File
        </Button>
    </div>;
}